export const TOKEN_EXPIRED = 'token expired';
export const INVALID_GRANT = 'invalid_grant';
export const BAD_TOKEN = 'Bad token';
